import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import DomainGroupingForm from './domain-grouping-form';
import {
    isAssigningDomainsToGroupSelector,
    isEditDomainGroupSelector,
    modalDomainGroupIdSelector,
    modalDomainsForAGroupSelector,
    modalDomainGroupNameSelector,
} from './domain-grouping-selectors';
import {
    domainGroupsSelector,
} from '../../common/selectors/domain-groups-selectors';
import { domainNamesSelector } from '../../common/selectors/domains-selectors';
import {
    createDomainGroup,
    selectDomainGroup,
    renameSelectedDomainGroup,
    updateDomainsInSelectedGroup,
    dismissDomainGroupingForm
} from '../../common/actions/domain-groups-action-creators';

export class DomainGroupingFormContainer extends Component{
    render(){
        const {
            assignMode,
            createDomainGroup,
            dismissDomainGroupingForm,
            domainGroups,
            domains,
            editMode,
            selectDomainGroup,
            selectedDomains,
            selectedGroupId,
            selectedGroupName,
            renameSelectedDomainGroup,
            updateDomainsInSelectedGroup,
        } = this.props;


        return (
            <DomainGroupingForm
                assignMode={assignMode}
                editMode={editMode}

                domainGroups={domainGroups}
                domains={domains}

                selectedGroupId={selectedGroupId}
                onSelectedGroupChange={selectDomainGroup}
                createDomainGroup={createDomainGroup}

                selectedGroupName={selectedGroupName}
                onGroupNameChange={renameSelectedDomainGroup}

                selectedDomains={selectedDomains}
                onDomainChange={updateDomainsInSelectedGroup}
                onDismiss={dismissDomainGroupingForm}
            />
        );
    }
}

/* istanbul ignore next */
const mapStateToProps = ( state ) => {
    return {
        assignMode: isAssigningDomainsToGroupSelector( state ),
        domainGroups: domainGroupsSelector( state ),
        domains: domainNamesSelector( state ),
        editMode: isEditDomainGroupSelector( state ),
        selectedDomains: modalDomainsForAGroupSelector( state ),
        selectedGroupId: modalDomainGroupIdSelector( state ),
        selectedGroupName: modalDomainGroupNameSelector( state ),
    };
};

DomainGroupingFormContainer.propTypes = {
    assignMode: PropTypes.bool.isRequired,
    createDomainGroup: PropTypes.func.isRequired,
    dismissDomainGroupingForm: PropTypes.func.isRequired,
    domainGroups: PropTypes.array.isRequired,
    domains: PropTypes.array.isRequired,
    editMode: PropTypes.bool.isRequired,
    renameSelectedDomainGroup: PropTypes.func.isRequired,
    selectDomainGroup: PropTypes.func.isRequired,
    selectedDomains: PropTypes.arrayOf( PropTypes.string ).isRequired,
    selectedGroupId: PropTypes.number,
    selectedGroupName: PropTypes.string,
    updateDomainsInSelectedGroup: PropTypes.func.isRequired,
};

export default connect(
    mapStateToProps,
    {
        createDomainGroup,
        dismissDomainGroupingForm,
        renameSelectedDomainGroup,
        selectDomainGroup,
        updateDomainsInSelectedGroup,
    },
)( DomainGroupingFormContainer );
